import { useQuery } from "@tanstack/react-query"

import { TESTIMONIALS_ENDPOINTS } from "@endpoints/testimonials"

import { Testimonial } from "./Testimonials.types"

export default function useTestimonials() {
    return useQuery<Testimonial[], Error>({
        queryKey: ["testimonials"],
        queryFn: async (): Promise<Testimonial[]> => {
            const response = await fetch(TESTIMONIALS_ENDPOINTS.LIST)
            if (!response.ok) {
                throw new Error("Failed to fetch testimonials")
            }
            const data = (await response.json()) as Testimonial[]
            return data || []
        },
        staleTime: 86400000, // 24 hours (matching backend cache)
    })
}
